/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable eqeqeq */
/*
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandiweb/gdpr-scandipwa
 * @author    Reinis Mazeiks <info@scandiweb.com>
 */
import { cloneElement, isValidElement } from 'react';

import { STATE_CONFIRM_EMAIL } from 'Component/MyAccountOverlay/MyAccountOverlay.config';

import PrivacyConsentCheckboxes from '../component/PrivacyConsentCheckboxes';
import { AREA_REGISTRATION, formatConsents } from '../util/Privacy';

export const renderSubmitButton = (args, callback, instance) => {
    const original = callback.apply(instance, args);
    if ((instance == null) || (instance == undefined)) {
        return (<></>);
    }
    if ((instance.props == null) || (instance.props == undefined)) {
        return (<></>);
    }
    const { updatePrivacyConsentSelection } = instance.props;

    return (
        <PrivacyConsentCheckboxes
          key="gdpr-consent-checkboxes"
          area={ AREA_REGISTRATION }
          updateRegistrationSelection={ updatePrivacyConsentSelection }
        >
            { original }
        </PrivacyConsentCheckboxes>
    );
};

/**
 * Completely replaces (copied) original implementation - need to add value privacyConsentSelection to customerData
 * @param args
 * @param callback
 * @param instance
 */
export const onCreateAccountSuccess = (args, callback, instance) => {
    const [fields] = args;

    const {
        privacyConsentSelection
    } = instance.state;

    const formattedConsentSelection = formatConsents(privacyConsentSelection);

    const {
        createAccount,
        onSignIn,
        setSignInState,
        setLoadingState,
        turnstileRecaptchaTokenValue
    } = instance.props;

    const {
        password,
        email,
        firstname,
        lastname,
        is_subscribed,
        yotpo_opted_in
    } = fields;

    const customerData = {
        customer: {
            firstname,
            lastname,
            email,
            is_subscribed,
            privacyConsentSelection: formattedConsentSelection,
            yotpo_opted_in,
            recaptcha_response: turnstileRecaptchaTokenValue
        },
        password
    };

    createAccount(customerData)
        .then(
            (code) => {
                // if user needs confirmation
                if (code === 2) {
                    setSignInState(STATE_CONFIRM_EMAIL);
                } else {
                    onSignIn();
                }

                setLoadingState(false);
            },
            () => {
                setLoadingState(false);
            }
        );
};

export const render = (args, callback, instance) => {
    const updatePrivacyConsentSelection = (selection) => {
        instance.setState({
            privacyConsentSelection: selection
        });
    };

    const original = callback.apply(instance, args);
    if (!isValidElement(original)) {
        return null;
    }

    // eslint-disable-next-line no-undef
    return cloneElement(
        original,
        { updatePrivacyConsentSelection },
        original.props.children
    );
};

export default {
    'Component/MyAccountCreateAccount/Component': {
        'member-function': {
            renderSubmitButton
        }
    },
    'Component/MyAccountCreateAccount/Container': {
        'member-function': {
            onCreateAccountSuccess,
            render
        }
    }
};
